export default __webpack_public_path__ + "static/media/istockphoto-654224782-170667a (1).fd2419e1.jpg";